const python_STROM_OS = function (Blockly) {




    Blockly.Python = new Blockly.Generator("Python");
    Blockly.Python.workspaceToCode = function (a) {
        a || (console.warn("No workspace specified in workspaceToCode call.  Guessing."), a = Blockly.getMainWorkspace());
        var b = [];
        this.init(a);
        a = a.getTopBlocks(!0);
        for (var c = 0, d; d = a[c]; c++) {
            if (!d.rendered || (d.type != "STORM_OS_jmd_start")) {
                continue
            }
            var e = this.blockToCode(d);

            Array.isArray(e) && (e = e[0]);
            e && (d.outputConnection && this.scrubNakedValue && (e = this.scrubNakedValue(e)), b.push(e))
        }
        b = b.join("\n");
        b = this.finish(b);
        b = b.replace(/^\s+\n/, "");
        b = b.replace(/\n\s+$/, "\n");
        return b = b.replace(/[ \t]+\n/g, "\n")
    };

    Blockly.Python.addReservedWords("False,None,True,and,as,assert,break,class,continue,def,del,elif,else,except,exec,finally,for,from,global,if,import,in,is,lambda,nonlocal,not,or,pass,print,raise,return,try,while,with,yield,NotImplemented,Ellipsis,__debug__,quit,exit,copyright,license,credits,ArithmeticError,AssertionError,AttributeError,BaseException,BlockingIOError,BrokenPipeError,BufferError,BytesWarning,ChildProcessError,ConnectionAbortedError,ConnectionError,ConnectionRefusedError,ConnectionResetError,DeprecationWarning,EOFError,Ellipsis,EnvironmentError,Exception,FileExistsError,FileNotFoundError,FloatingPointError,FutureWarning,GeneratorExit,IOError,ImportError,ImportWarning,IndentationError,IndexError,InterruptedError,IsADirectoryError,KeyError,KeyboardInterrupt,LookupError,MemoryError,ModuleNotFoundError,NameError,NotADirectoryError,NotImplemented,NotImplementedError,OSError,OverflowError,PendingDeprecationWarning,PermissionError,ProcessLookupError,RecursionError,ReferenceError,ResourceWarning,RuntimeError,RuntimeWarning,StandardError,StopAsyncIteration,StopIteration,SyntaxError,SyntaxWarning,SystemError,SystemExit,TabError,TimeoutError,TypeError,UnboundLocalError,UnicodeDecodeError,UnicodeEncodeError,UnicodeError,UnicodeTranslateError,UnicodeWarning,UserWarning,ValueError,Warning,ZeroDivisionError,_,__build_class__,__debug__,__doc__,__import__,__loader__,__name__,__package__,__spec__,abs,all,any,apply,ascii,basestring,bin,bool,buffer,bytearray,bytes,callable,chr,classmethod,cmp,coerce,compile,complex,copyright,credits,delattr,dict,dir,divmod,enumerate,eval,exec,execfile,exit,file,filter,float,format,frozenset,getattr,globals,hasattr,hash,help,hex,id,input,int,intern,isinstance,issubclass,iter,len,license,list,locals,long,map,max,memoryview,min,next,object,oct,open,ord,pow,print,property,quit,range,raw_input,reduce,reload,repr,reversed,round,set,setattr,slice,sorted,staticmethod,str,sum,super,tuple,type,unichr,unicode,vars,xrange,zip");
    Blockly.Python.ORDER_ATOMIC = 0;
    Blockly.Python.ORDER_COLLECTION = 1;
    Blockly.Python.ORDER_STRING_CONVERSION = 1;
    Blockly.Python.ORDER_MEMBER = 2.1;
    Blockly.Python.ORDER_FUNCTION_CALL = 2.2;
    Blockly.Python.ORDER_EXPONENTIATION = 3;
    Blockly.Python.ORDER_UNARY_SIGN = 4;
    Blockly.Python.ORDER_BITWISE_NOT = 4;
    Blockly.Python.ORDER_MULTIPLICATIVE = 5;
    Blockly.Python.ORDER_ADDITIVE = 6;
    Blockly.Python.ORDER_BITWISE_SHIFT = 7;
    Blockly.Python.ORDER_BITWISE_AND = 8;
    Blockly.Python.ORDER_BITWISE_XOR = 9;
    Blockly.Python.ORDER_BITWISE_OR = 10;
    Blockly.Python.ORDER_RELATIONAL = 11;
    Blockly.Python.ORDER_LOGICAL_NOT = 12;
    Blockly.Python.ORDER_LOGICAL_AND = 13;
    Blockly.Python.ORDER_LOGICAL_OR = 14;
    Blockly.Python.ORDER_CONDITIONAL = 15;
    Blockly.Python.ORDER_LAMBDA = 16;
    Blockly.Python.ORDER_NONE = 99;
    Blockly.Python.ORDER_OVERRIDES = [
        [Blockly.Python.ORDER_FUNCTION_CALL, Blockly.Python.ORDER_MEMBER],
        [Blockly.Python.ORDER_FUNCTION_CALL, Blockly.Python.ORDER_FUNCTION_CALL],
        [Blockly.Python.ORDER_MEMBER, Blockly.Python.ORDER_MEMBER],
        [Blockly.Python.ORDER_MEMBER, Blockly.Python.ORDER_FUNCTION_CALL],
        [Blockly.Python.ORDER_LOGICAL_NOT, Blockly.Python.ORDER_LOGICAL_NOT],
        [Blockly.Python.ORDER_LOGICAL_AND, Blockly.Python.ORDER_LOGICAL_AND],
        [Blockly.Python.ORDER_LOGICAL_OR, Blockly.Python.ORDER_LOGICAL_OR],
        [2, 1]
    ];
    Blockly.Variables.allUsedVariabless = function (a) {
        if (a instanceof Blockly.Block) var b = a.getDescendants(!1);
        else if (a instanceof Blockly.Workspace || a instanceof Blockly.WorkspaceSvg) b = a.getAllBlocks();
        else throw new Error("Not Block or Workspace: " + a);
        var c = Blockly.Variables.noVariableText();
        a = Object.create(null);
        for (var d = 0; d < b.length; d++) {
            var e = b[d].getVarModels();
            if (e)
                for (var f = 0; f < e.length; f++) {
                    var g = e[f];
                    // g.getId() && g.name.toLowerCase() != c && (a[g.name.toLowerCase()] = g.name)
                    if (g.getId() && g.name.toLowerCase() !== c) {
                        if (g.type === "") {
                            if (!a['']) {
                                a[''] = {}
                            }
                            a[''][g.name.toLowerCase()] = g.name
                        } else if (g.type === "list") {
                            if (!a['list']) {
                                a['list'] = {}
                            }
                            a['list'][g.name.toLowerCase()] = g.name
                        } else {

                        }
                    }
                }
        }
        let obj = {}
        for (let i in a) {
            let b = []
            for (let j in a[i]) {
                b.push(a[i][j])
            }
            obj[i] = b
        }

        // b = [];
        // for (var h in a) b.push(a[h]);
        return obj
    };
    Blockly.Python.init = function (a) {
        Blockly.Python.PASS = this.INDENT + "pass\n";
        Blockly.Python.definitions_ = Object.create(null);
        Blockly.Python.functionNames_ = Object.create(null);
        Blockly.Python.jmdstart = Object.create(null); //拿到头部文件作为最后的函数调用
        Blockly.Python.list = Object.create(null);
        Blockly.Python.varibles = new Array();
        Blockly.Python.variableDB_ ? Blockly.Python.variableDB_.reset() : Blockly.Python.variableDB_ = new Blockly.Names(Blockly.Python.RESERVED_WORDS_);
        Blockly.Python.variableDB_.setVariableMap(a.getVariableMap());
        for (var b = [], c = Blockly.Variables.allDeveloperVariables(a), d = 0; d < c.length; d++) b.push(c[d] +
            " = 0");
        // a = Blockly.Variables.allUsedVariables(a);
        a = Blockly.Variables.allUsedVariabless(a)
        for (let i in a) {
            for (let j in a[i]) {
                let varname = a[i][j]
                if (i === "") {
                    varname = 'var_' + varname
                    b.push(varname + " = 0")
                } else {
                    varname = 'list_' + varname
                    b.push(varname + " = []")
                }
                Blockly.Python.varibles.push(varname)
            }
        }
        // for (d = 0; d < a.length; d++) {
        //     Blockly.Python.varibles.push(a[d])
        //     if (a[d].type == "lists") {
        //         b.push(a[d] + " = []")
        //     } else {
        //         b.push(a[d] + " = 0")
        //     }
        // };
        Blockly.Python.definitions_.RCU_ = "from ZMSensors_RCU import *"
        Blockly.Python.definitions_.utils_ImageShow = "from SenseTime.utils.ImageShow import *"
        Blockly.Python.definitions_.utils_Sensor = "from SenseTime.utils.Sensor import *"
        Blockly.Python.definitions_.utils_Motor = "from SenseTime.utils.Motor import *"
        Blockly.Python.definitions_.utils_Event = "from SenseTime.utils.Event import *"
        Blockly.Python.definitions_.utils_API = "from SenseTime.utils.API import *"


        Blockly.Python.definitions_.variables = b.join("\n")
    };
    Blockly.Python.finish = function (a) {
        var b = [],
            c = [],
            f = [],
            h = [],
            d,
            l = '';
        for (d in Blockly.Python.definitions_) {
            var e = Blockly.Python.definitions_[d];
            e.match(/^(from\s+\S+\s+)?import\s+\S+/) ? b.push(e) : c.push(e)
        }
        //遍历有多少个头部块，就在最后添加对应的函数调用
        // for (var g in Blockly.Python.jmdstart) {
        //     f.push(Blockly.Python.jmdstart[g] + "()")
        // }

        //遍历列表的所有参数
        for (let i in Blockly.Python.list) {
            h.push(i)
            l += i + '=[]\n'
        }
        a = Blockly.Python.varibles.length > 0 ? a.replace(/\[GLOBAL]/g, "\r\n  global " + Blockly.Python.varibles.join(',')) : a.replace(/\[GLOBAL]/g, '')

        var thrad = f.length > 1 ? "import _thread\r\n" : ""
        var thradEnd = f.length > 1 ? Blockly.Python.mainEnd(f) : f.join("\r\n")

        delete Blockly.Python.definitions_;
        delete Blockly.Python.functionNames_;
        delete Blockly.Python.jmdstart;
        Blockly.Python.variableDB_.reset();
        return thrad + (b.join("\n") + "\n\n" + l + c.join("\n\n")).replace(/\n\n+/g, "\n\n").replace(/\n*$/, "\n\n") + a + "\n" + thradEnd
    };
    Blockly.Python.mainEnd = function (a) {
        let top = "def main():\r\n"
        for (let b in a) {
            top += "  _thread.start_new_thread(" + a[b].replace("()", "") + ",())\r\n"
        }
        top += "\r\nmain()\r\n\r\nwhile 1:\r\n  pass"
        return top
    };
    Blockly.Python.scrubNakedValue = function (a) {
        return a + "\n"
    };
    Blockly.Python.quote_ = function (a) {
        a = a.replace(/\\/g, "\\\\").replace(/\n/g, "\\\n");
        var b = "'"; - 1 !== a.indexOf("'") && (-1 === a.indexOf('"') ? b = '"' : a = a.replace(/'/g, "\\'"));
        return b + a + b
    };
    Blockly.Python.multiline_quote_ = function (a) {
        a = a.replace(/'''/g, "\\'\\'\\'");
        return "'''" + a + "'''"
    };
    Blockly.Python.scrub_ = function (a, b, c) {
        var d = "";
        if (!a.outputConnection || !a.outputConnection.targetConnection) {
            var e = a.getCommentText();
            if (e) {
                e = Blockly.utils.wrap(e, Blockly.Python.COMMENT_WRAP - 3)
                d += Blockly.Python.prefixLines(e + "\n", "# ")
            }
            // e && (e = Blockly.utils.wrap(e, Blockly.Python.COMMENT_WRAP - 3), d += Blockly.Python.prefixLines(e + "\n", "# "));
            for (var f = 0; f < a.inputList.length; f++) a.inputList[f].type === Blockly.INPUT_VALUE && (e = a.inputList[f].connection.targetBlock()) && (e = Blockly.Python.allNestedComments(e)) && (d += Blockly.Python.prefixLines(e, "# "))
        }
        a = a.nextConnection && a.nextConnection.targetBlock();
        c =
            c ? "" : Blockly.Python.blockToCode(a);
        return d + b + c
    };
    // Blockly.Python.getAdjustedInt = function (a, b, c, d) {
    //     c = c || 0;
    //     a.workspace.options.oneBasedIndex && c--;
    //     var e = a.workspace.options.oneBasedIndex ? "1" : "0";
    //     a = Blockly.Python.valueToCode(a, b, c ? Blockly.Python.ORDER_ADDITIVE : Blockly.Python.ORDER_NONE) || e;
    //     Blockly.isNumber(a) ? (a = parseInt(a, 10) + c, d && (a = -a)) : (a = 0 < c ? "int(" + a + " + " + c + ")" : 0 > c ? "int(" + a + " - " + -c + ")" : "int(" + a + ")", d && (a = "-" + a));
    //     return a
    // };
    Blockly.Python.transformColor = function (color) {
        var colors = color.slice(1)
        var newColors = ''
        for (var j = 0; j < colors.length; j++) {
            if (colors[j] !== '0') {
                newColors = colors.slice(j)
                break;
            } else if (colors == '000000') {
                newColors = '0'
                break;
            }
        }
        var newColor = '';
        for (var i = 0; i < newColors.length; i++) {
            newColor += newColors[i].toLocaleUpperCase()
        }
        return '0x' + newColor

    }

    Blockly.Python.matrixToString16 = function (matrix) {
        let arr = []
        for (var i = 0; i < matrix.length;) {
            // 字符串翻转
            var length = (matrix.slice(i, i + 8)).length;
            length = length - 1;
            var newstr = ''
            for (var x = length; x >= 0; x--) {
                newstr += (matrix.slice(i, i + 8)).charAt(x);
            }

            arr.push(newstr)
            i += 8
        }
        let value = ''
        for (var j = 0; j < arr.length; j++) {
            let temp = parseInt(arr[j], 2)
            temp = temp.toString(16)
            // 十六进制，不够两位补0
            let zero = '00';
            let tmp = 2 - temp.length;
            value += zero.substr(0, tmp) + temp;

        }
        return value
    }

    Blockly.Python.argumentToArrayString = function () {
        let concatAry = [...arguments]
        concatAry = concatAry.filter(item => item != "-")
        let params = "["
        concatAry.forEach((item, index) => {
            if (index == 0) {
                params += item
            } else {
                params += "," + item
            }
        })
        params += "]"
        return params
    }


    //-------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------





    Blockly.Python.pass = "    pass\n";

    Blockly.Python.jmd_start = function (a) {
        let task = a.getFieldValue("TASK");
        let passEnd = a.getNextBlock() ? "" : "  pass\n"
        Blockly.Python.jmdstart[a.id] = task;
        return "def " + task + "():[GLOBAL]\r\n" + passEnd;
    };
    Blockly.Python.jmd_getBatteryVoltage = function (a) {
        return ["GetInVotage()", 1];
    };
    Blockly.Python.jmd_getControlTime = function (a) {
        return ["GetSysTime()", 1];
    };
    Blockly.Python.jmd_setControlTimeZero = function (a) {
        return "SetSysTime()\r\n";
    };
    Blockly.Python.STORM_OS_record_audio = function (a) {
        let second = Blockly.Python.valueToCode(a, "SECOND", 2);
        let fileName = Blockly.Python.valueToCode(a, "FILENAME", 2);
        Blockly.Python.definitions_.utilsAudioClassifier = "from SenseTime.utils.AudioClassifier import *"
        return `record_audio(${second},${fileName})\r\n`;
    };
    Blockly.Python.STORM_OS_play_preset_audio = function (a) {
        let file = a.getFieldValue("FILE");
        Blockly.Python.definitions_.utilsAudioClassifier = "from SenseTime.utils.AudioClassifier import *"
        return `play_preset_audio("${file}")\r\n`;
    };
    Blockly.Python.STORM_OS_play_audio = function (a) {
        let fileName = Blockly.Python.valueToCode(a, "FILENAME", 2);
        Blockly.Python.definitions_.utilsAudioClassifier = "from SenseTime.utils.AudioClassifier import *"
        return `play_audio(${fileName})\r\n`;
    };
    Blockly.Python.STORM_OS_tone = function (a) {
        let volume = Blockly.Python.valueToCode(a, "VOLUME", 2);
        let second = Blockly.Python.valueToCode(a, "SECOND", 2);
        Blockly.Python.definitions_.utilsAudioClassifier = "from SenseTime.utils.AudioClassifier import *"
        return `tone(${volume},${second})\r\n`;
    };
    Blockly.Python.STORM_OS_beep = function (a) {
        Blockly.Python.definitions_.utilsAudioClassifier = "from SenseTime.utils.AudioClassifier import *"
        return `beep()\r\n`;
    };
    Blockly.Python.STORM_OS_fan_speed = function (a) {
        return ["fan_speed()", 1];
    };

    Blockly.Python.STORM_OS_set_fan_speed = function (a) {
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        return `set_fan_speed(${speed})\r\n`;
    };

    Blockly.Python.STORM_OS_fw_version = function (a) {
        return ["fw_version()", 1];
    };
    Blockly.Python.STORM_OS_battery = function (a) {
        return ["battery()", 1];
    };
    Blockly.Python.STORM_OS_charging = function (a) {
        return ["charging()", 1];
    };
    Blockly.Python.STORM_OS_reset = function (a) {
        return ["reset()", 1];
    };



    //马达

    Blockly.Python.motor_setMotor = function (a, b, c) {
        let motorport = a.getFieldValue("MOTORPORT");
        let value = Blockly.Python.valueToCode(a, "VALUE", 2);
        return "set_motor_speed(" + motorport + "," + value + ")\r\n";
    };
    Blockly.Python.motor_getMotorCode = function (a, b, c) {
        let motorport = a.getFieldValue("MOTORPORT");
        return ["get_motor_code(" + motorport + ")", 1];
    };
    Blockly.Python.motor_setMotorCode = function (a, b, c) {
        let motorport = a.getFieldValue("MOTORPORT");
        return "clear_motor_code(" + motorport + ")\r\n";
    };
    Blockly.Python.motor_setServoMotor = function (a, b, c) {
        let motorport = a.getFieldValue("PORT");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "set_motor_servo_asyn(" + motorport + "," + angle + "," + speed + ")\r\n";
    };
    Blockly.Python.motor_waitServomotor = function (a, b, c) {
        let motorport = a.getFieldValue("PORT");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "SetWaitForAngle(" + motorport + "," + speed + "," + angle + ")\r\n";
    };

    Blockly.Python.motor_setServo = function (a, b, c) {
        let prop = a.getFieldValue("PROP");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "SetServo(" + prop + "," + angle + ")\r\n";
    };
    Blockly.Python.motor_setServo_OS = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return "set_steering(" + prop + "," + angle + ")\r\n";
    };

    Blockly.Python.STORM_OS_set_motor_speed = function (a, b, c) {
        let prop = a.getFieldValue("MOTORPORT");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        return `set_motor_speed(${prop},${speed})\r\n`;
    };

    Blockly.Python.STORM_OS_set_motors_speed = function (a, b, c) {
        let prop1 = a.getFieldValue("MOTORPORT1");
        let prop2 = a.getFieldValue("MOTORPORT2");
        let prop3 = a.getFieldValue("MOTORPORT3");
        let prop4 = a.getFieldValue("MOTORPORT4");
        let speed1 = Blockly.Python.valueToCode(a, "SPEED1", 2);
        let speed2 = Blockly.Python.valueToCode(a, "SPEED2", 2);
        let speed3 = Blockly.Python.valueToCode(a, "SPEED3", 2);
        let speed4 = Blockly.Python.valueToCode(a, "SPEED4", 2);
        let params = Blockly.Python.argumentToArrayString(prop1, prop2, prop3, prop4)
        let speeds = Blockly.Python.argumentToArrayString(speed1, speed2, speed3, speed4)
        return `set_motors_speed(${params},${speeds})\r\n`;
    };


    Blockly.Python.STORM_OS_get_motor_code = function (a, b, c) {
        let prop = a.getFieldValue("MOTORPORT");
        return [`get_motor_code(${prop})`, 1];
    };
    Blockly.Python.STORM_OS_get_motors_code = function (a, b, c) {
        let prop1 = a.getFieldValue("MOTORPORT1");
        let prop2 = a.getFieldValue("MOTORPORT2");
        let prop3 = a.getFieldValue("MOTORPORT3");
        let prop4 = a.getFieldValue("MOTORPORT4");
        let params = Blockly.Python.argumentToArrayString(prop1, prop2, prop3, prop4)
        return [`get_motors_code(${params})`, 1];
    };

    Blockly.Python.STORM_OS_clear_motor_code = function (a, b, c) {
        let prop = a.getFieldValue("MOTORPORT");
        return `clear_motor_code(${prop})\r\n`;
    };
    Blockly.Python.STORM_OS_clear_motors_code = function (a, b, c) {
        let prop1 = a.getFieldValue("MOTORPORT1");
        let prop2 = a.getFieldValue("MOTORPORT2");
        let prop3 = a.getFieldValue("MOTORPORT3");
        let prop4 = a.getFieldValue("MOTORPORT4");
        let params = Blockly.Python.argumentToArrayString(prop1, prop2, prop3, prop4)
        return `clear_motors_code(${params})\r\n`;
    };
    Blockly.Python.STORM_OS_set_motor_servo_asyn = function (a, b, c) {
        let prop = a.getFieldValue("MOTORPORT");
        let speed = Blockly.Python.valueToCode(a, "SPEED", 2);
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return `set_motor_servo_asyn(${prop},${angle},${speed})\r\n`;
    };
    Blockly.Python.STORM_OS_set_motors_servo_asyn = function (a, b, c) {
        let prop1 = a.getFieldValue("MOTORPORT1");
        let prop2 = a.getFieldValue("MOTORPORT2");
        let prop3 = a.getFieldValue("MOTORPORT3");
        let prop4 = a.getFieldValue("MOTORPORT4");
        let speed1 = Blockly.Python.valueToCode(a, "SPEED1", 2);
        let speed2 = Blockly.Python.valueToCode(a, "SPEED2", 2);
        let speed3 = Blockly.Python.valueToCode(a, "SPEED3", 2);
        let speed4 = Blockly.Python.valueToCode(a, "SPEED4", 2);
        let angle1 = Blockly.Python.valueToCode(a, "ANGLE1", 2);
        let angle2 = Blockly.Python.valueToCode(a, "ANGLE2", 2);
        let angle3 = Blockly.Python.valueToCode(a, "ANGLE3", 2);
        let angle4 = Blockly.Python.valueToCode(a, "ANGLE4", 2);
        let params = Blockly.Python.argumentToArrayString(prop1, prop2, prop3, prop4)
        let speeds = Blockly.Python.argumentToArrayString(speed1, speed2, speed3, speed4)
        let angles = Blockly.Python.argumentToArrayString(angle1, angle2, angle3, angle4)
        return `set_motors_servo_asyn(${params},${angles},${speeds})\r\n`;
    };


    Blockly.Python.STORM_OS_motor_servo_unlock = function (a, b, c) {
        let prop = a.getFieldValue("MOTORPORT");
        return `motor_servo_unlock(${prop})\r\n`;
    };
    Blockly.Python.STORM_OS_motors_servo_unlock = function (a, b, c) {
        let prop1 = a.getFieldValue("MOTORPORT1");
        let prop2 = a.getFieldValue("MOTORPORT2");
        let prop3 = a.getFieldValue("MOTORPORT3");
        let prop4 = a.getFieldValue("MOTORPORT4");
        let params = Blockly.Python.argumentToArrayString(prop1, prop2, prop3, prop4)
        return `motors_servo_unlock(${params})\r\n`;
    };

    Blockly.Python.STORM_OS_set_steering = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return `set_steering(${prop},${angle})\r\n`;
    };
    Blockly.Python.STORM_OS_set_steerings = function (a, b, c) {
        let prop1 = a.getFieldValue("PORT1");
        let prop2 = a.getFieldValue("PORT2");
        let prop3 = a.getFieldValue("PORT3");
        let angle1 = Blockly.Python.valueToCode(a, "ANGLE1", 2);
        let angle2 = Blockly.Python.valueToCode(a, "ANGLE2", 2);
        let angle3 = Blockly.Python.valueToCode(a, "ANGLE3", 2);
        let params = Blockly.Python.argumentToArrayString(prop1, prop2, prop3)
        let angles = Blockly.Python.argumentToArrayString(angle1, angle2, angle3)
        return `set_steerings(${params},${angles})\r\n`;
    };
    Blockly.Python.STORM_OS_set_steering_unlock = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        let angle = Blockly.Python.valueToCode(a, "ANGLE", 2);
        return `set_steering_unlock(${prop},${angle})\r\n`;
    };
    Blockly.Python.STORM_OS_set_steerings_unlock = function (a, b, c) {
        let prop1 = a.getFieldValue("PORT1");
        let prop2 = a.getFieldValue("PORT2");
        let prop3 = a.getFieldValue("PORT3");
        let angle1 = Blockly.Python.valueToCode(a, "ANGLE1", 2);
        let angle2 = Blockly.Python.valueToCode(a, "ANGLE2", 2);
        let angle3 = Blockly.Python.valueToCode(a, "ANGLE3", 2);
        let params = Blockly.Python.argumentToArrayString(prop1, prop2, prop3)
        let angles = Blockly.Python.argumentToArrayString(angle1, angle2, angle3)
        return `set_steerings_unlock(${params},${angles})\r\n`;
    };

    Blockly.Python.STORM_OS_steering_unlock = function (a, b, c) {
        let prop = a.getFieldValue("PORT");
        return `steering_unlock(${prop})\r\n`;
    };
    Blockly.Python.STORM_OS_steerings_unlock = function (a, b, c) {
        let prop1 = a.getFieldValue("PORT1");
        let prop2 = a.getFieldValue("PORT2");
        let prop3 = a.getFieldValue("PORT3");
        let params = Blockly.Python.argumentToArrayString(prop1, prop2, prop3)
        return `steerings_unlock(${params})\r\n`;
    };



    //控制
    Blockly.Python.math_positive_number = function (a) {
        let num = a.getFieldValue('NUM');
        return [num, 1];
    };
    Blockly.Python.control_wait = function (a) {
        let time = Blockly.Python.valueToCode(a, "DURATION", 2);
        return "SetWaitForTime(" + time + ")\r\n";
    };
    Blockly.Python.control_repeat = function (block) {
        let time = Blockly.Python.valueToCode(block, "TIMES", 2);
        let branch = Blockly.Python.statementToCode(block, "SUBSTACK");
        branch = branch ? (Blockly.Python.addLoopTrap(branch, branch) || Blockly.Python.pass) : Blockly.Python.pass;
        return "for count in range(" + time + "):\r\n" + branch;
    };
    Blockly.Python.control_forever = function (block) {
        let branch = Blockly.Python.statementToCode(block, "SUBSTACK");
        branch = Blockly.Python.addLoopTrap(branch, branch) || Blockly.Python.pass;
        return "while True:\r\n" + branch;
    };
    Blockly.Python.control_if = function (block) {
        let bool = Blockly.Python.valueToCode(block, "CONDITION", 2);
        if (bool === "") {
            bool = "FALSE";
        }
        let branch = Blockly.Python.statementToCode(block, "SUBSTACK");
        branch = Blockly.Python.addLoopTrap(branch, branch) || Blockly.Python.pass;
        return "if " + bool + ":\r\n" + branch;
    };
    Blockly.Python.control_if_else = function (block) {
        let bool = Blockly.Python.valueToCode(block, "CONDITION", 2);
        if (bool === "") {
            bool = "FALSE";
        }
        let branch1 = Blockly.Python.statementToCode(block, "SUBSTACK", 2);
        branch1 = Blockly.Python.addLoopTrap(branch1, branch1) || Blockly.Python.pass;
        let branch2 = Blockly.Python.statementToCode(block, "SUBSTACK2");
        branch2 = Blockly.Python.addLoopTrap(branch2, branch2) || Blockly.Python.pass;
        return "if " + bool + ":\r\n" + branch1 + "else:\r\n" + branch2;
    };
    Blockly.Python.control_wait_until = function (block) {
        let bool = Blockly.Python.valueToCode(block, "CONDITION", 2);
        console.log(bool)
        return "while not(" + bool + "):\r\n    pass\r\n";
    };
    Blockly.Python.control_repeat_until = function (block) {
        let bool = Blockly.Python.valueToCode(block, "CONDITION", 2);
        console.log(bool)
        let branch = Blockly.Python.statementToCode(block, "SUBSTACK");
        branch = Blockly.Python.addLoopTrap(branch, branch) || Blockly.Python.pass;
        return "while not(" + bool + "):\r\n" + branch;
    };


    //传感器

    Blockly.Python.STORM_OS_getColorRGB = function (a) {
        let prop = a.getFieldValue("COLORPORT");
        return ["color_value(" + prop + ")", 1];
    };
    Blockly.Python.STORM_OS_getColorRGB_values = function (a) {
        let prop1 = a.getFieldValue("PORT1");
        let prop2 = a.getFieldValue("PORT2");
        let prop3 = a.getFieldValue("PORT3");
        let prop4 = a.getFieldValue("PORT4");
        let prop5 = a.getFieldValue("PORT5");
        let prop6 = a.getFieldValue("PORT6");
        let prop7 = a.getFieldValue("PORT7");
        let prop8 = a.getFieldValue("PORT8");
        let params = Blockly.Python.argumentToArrayString(prop1, prop2, prop3, prop4, prop5, prop6, prop7, prop8)

        return [`color_values(${params})`, 1]
    };

    Blockly.Python.sensor_getLightSensorDigital = function (a) {
        let prop = a.getFieldValue("SENSORPORT");
        return ["GetLightSensorData(" + prop + ")", 1];
    };
    Blockly.Python.sensor_setLightSensor = function (a) {
        let prop = a.getFieldValue("SENSORPORT");
        let state = a.getFieldValue("STATE");
        return "SetLightSensorLed(" + prop + "," + state + ")\r\n";
    };
    Blockly.Python.STORM_OS_getLightSensor = function (a) {
        let prop1 = a.getFieldValue("PORT1");
        return [`photo_electric_value(${prop1})`, 1]
    };
    Blockly.Python.STORM_OS_getLightSensor_values = function (a) {
        let prop1 = a.getFieldValue("PORT1");
        let prop2 = a.getFieldValue("PORT2");
        let prop3 = a.getFieldValue("PORT3");
        let prop4 = a.getFieldValue("PORT4");
        let prop5 = a.getFieldValue("PORT5");
        let prop6 = a.getFieldValue("PORT6");
        let prop7 = a.getFieldValue("PORT7");
        let prop8 = a.getFieldValue("PORT8");
        let params = Blockly.Python.argumentToArrayString(prop1, prop2, prop3, prop4, prop5, prop6, prop7, prop8)

        return [`photo_electric_values(${params})`, 1]
    };
    Blockly.Python.STORM_OS_set_photo_electric_threshold = function (a) {
        let prop1 = a.getFieldValue("PORT1");
        let value = Blockly.Python.valueToCode(a, "VALUE", 2);
        return "set_photo_electric_threshold(" + prop1 + "," + value + ")\r\n";
    };
    Blockly.Python.STORM_OS_light_open = function (a) {
        let prop1 = a.getFieldValue("PORT1");
        return "supplement_light_open(" + prop1 + ")\r\n";
    };
    Blockly.Python.STORM_OS_light_close = function (a) {
        let prop1 = a.getFieldValue("PORT1");
        return "supplement_light_close(" + prop1 + ")\r\n";
    };

    Blockly.Python.STORM_OS_touch_value = function (a) {
        let prop1 = a.getFieldValue("PORT1");
        return [`touch_value(${prop1})`, 1]
    };
    Blockly.Python.STORM_OS_touch_values = function (a) {
        let prop1 = a.getFieldValue("PORT1");
        let prop2 = a.getFieldValue("PORT2");
        let prop3 = a.getFieldValue("PORT3");
        let prop4 = a.getFieldValue("PORT4");
        let prop5 = a.getFieldValue("PORT5");
        let prop6 = a.getFieldValue("PORT6");
        let prop7 = a.getFieldValue("PORT7");
        let prop8 = a.getFieldValue("PORT8");
        let params = Blockly.Python.argumentToArrayString(prop1, prop2, prop3, prop4, prop5, prop6, prop7, prop8)

        return [`touch_values(${params})`, 1]
    };

    Blockly.Python.STORM_OS_getUltrasonic = function (a) {
        let prop1 = a.getFieldValue("PORT1");
        return [`ultrasonic_value(${prop1})`, 1]
    };
    Blockly.Python.STORM_OS_getUltrasonic_values = function (a) {
        let prop1 = a.getFieldValue("PORT1");
        let prop2 = a.getFieldValue("PORT2");
        let prop3 = a.getFieldValue("PORT3");
        let prop4 = a.getFieldValue("PORT4");
        let prop5 = a.getFieldValue("PORT5");
        let prop6 = a.getFieldValue("PORT6");
        let prop7 = a.getFieldValue("PORT7");
        let prop8 = a.getFieldValue("PORT8");
        let params = Blockly.Python.argumentToArrayString(prop1, prop2, prop3, prop4, prop5, prop6, prop7, prop8)

        return [`ultrasonic_values(${params})`, 1]
    };
    Blockly.Python.STORM_OS_humidity_value = function (a) {
        let prop1 = a.getFieldValue("PORT1");
        return [`humidity_value(${prop1})`, 1]
    };
    Blockly.Python.STORM_OS_humidity_values = function (a) {
        let prop1 = a.getFieldValue("PORT1");
        let prop2 = a.getFieldValue("PORT2");
        let prop3 = a.getFieldValue("PORT3");
        let prop4 = a.getFieldValue("PORT4");
        let prop5 = a.getFieldValue("PORT5");
        let prop6 = a.getFieldValue("PORT6");
        let prop7 = a.getFieldValue("PORT7");
        let prop8 = a.getFieldValue("PORT8");
        let params = Blockly.Python.argumentToArrayString(prop1, prop2, prop3, prop4, prop5, prop6, prop7, prop8)

        return [`humidity_values(${params})`, 1]
    };
    Blockly.Python.STORM_OS_temperature_value = function (a) {
        let prop1 = a.getFieldValue("PORT1");
        return [`temperature_value(${prop1})`, 1]
    };
    Blockly.Python.STORM_OS_temperature_values = function (a) {
        let prop1 = a.getFieldValue("PORT1");
        let prop2 = a.getFieldValue("PORT2");
        let prop3 = a.getFieldValue("PORT3");
        let prop4 = a.getFieldValue("PORT4");
        let prop5 = a.getFieldValue("PORT5");
        let prop6 = a.getFieldValue("PORT6");
        let prop7 = a.getFieldValue("PORT7");
        let prop8 = a.getFieldValue("PORT8");
        let params = Blockly.Python.argumentToArrayString(prop1, prop2, prop3, prop4, prop5, prop6, prop7, prop8)

        return [`temperature_values(${params})`, 1]
    };
    Blockly.Python.STORM_OS_compass_value = function (a) {
        let prop1 = a.getFieldValue("PORT1");
        return [`compass_value(${prop1})`, 1]
    };
    Blockly.Python.STORM_OS_compass_values = function (a) {
        let prop1 = a.getFieldValue("PORT1");
        let prop2 = a.getFieldValue("PORT2");
        let prop3 = a.getFieldValue("PORT3");
        let prop4 = a.getFieldValue("PORT4");
        let prop5 = a.getFieldValue("PORT5");
        let prop6 = a.getFieldValue("PORT6");
        let prop7 = a.getFieldValue("PORT7");
        let prop8 = a.getFieldValue("PORT8");
        let params = Blockly.Python.argumentToArrayString(prop1, prop2, prop3, prop4, prop5, prop6, prop7, prop8)

        return [`compass_values(${params})`, 1]
    };
    Blockly.Python.STORM_OS_gyroscope_init = function (a) {
        let prop1 = a.getFieldValue("PORT1");
        return `gyroscope_init(${prop1})\r\n`;
    };
    Blockly.Python.STORM_OS_gyroscope_value = function (a) {
        let prop1 = a.getFieldValue("PORT1");
        return [`gyroscope_value(${prop1})`, 1]
    };
    Blockly.Python.STORM_OS_gyroscope_values = function (a) {
        let prop1 = a.getFieldValue("PORT1");
        let prop2 = a.getFieldValue("PORT2");
        let prop3 = a.getFieldValue("PORT3");
        let prop4 = a.getFieldValue("PORT4");
        let prop5 = a.getFieldValue("PORT5");
        let prop6 = a.getFieldValue("PORT6");
        let prop7 = a.getFieldValue("PORT7");
        let prop8 = a.getFieldValue("PORT8");
        let params = Blockly.Python.argumentToArrayString(prop1, prop2, prop3, prop4, prop5, prop6, prop7, prop8)

        return [`gyroscope_values(${params})`, 1]
    };
    Blockly.Python.STORM_OS_set_color_light = function (a) {
        let prop1 = a.getFieldValue("PORT1");
        let color1 = a.getFieldValue("COLOR1");
        return `set_color_light(${prop1},${color1})\r\n`
    };

    Blockly.Python.STORM_OS_set_color_lights = function (a) {
        let prop1 = a.getFieldValue("PORT1");
        let prop2 = a.getFieldValue("PORT2");
        let prop3 = a.getFieldValue("PORT3");
        let prop4 = a.getFieldValue("PORT4");
        let prop5 = a.getFieldValue("PORT5");
        let prop6 = a.getFieldValue("PORT6");
        let prop7 = a.getFieldValue("PORT7");
        let prop8 = a.getFieldValue("PORT8");
        let color1 = a.getFieldValue("COLOR1");
        let color2 = a.getFieldValue("COLOR2");
        let color3 = a.getFieldValue("COLOR3");
        let color4 = a.getFieldValue("COLOR4");
        let color5 = a.getFieldValue("COLOR5");
        let color6 = a.getFieldValue("COLOR6");
        let color7 = a.getFieldValue("COLOR7");
        let color8 = a.getFieldValue("COLOR8");
        let params = Blockly.Python.argumentToArrayString(prop1, prop2, prop3, prop4, prop5, prop6, prop7, prop8)
        let colors = Blockly.Python.argumentToArrayString(color1, color2, color3, color4, color5, color6, color7, color8)

        return `set_color_lights(${params},${colors})\r\n`
    };



    // storm_os 图像

    Blockly.Python.STORM_OS_take_photo = function (block) {
        return [`take_photo()`, 1];
    };
    Blockly.Python.STORM_OS_imshow_sensestorm = function (block) {
        let img = Blockly.Python.valueToCode(block, "IMG", 2);
        return `imshow_sensestorm(${img})\r\n`;
    };
    Blockly.Python.STORM_OS_imread_sensestorm = function (block) {
        let path = Blockly.Python.valueToCode(block, "PATH", 2);
        return [`imread(${path})`, 1];
    };
    Blockly.Python.STORM_OS_imwrite_sensestorm = function (block) {
        let img = Blockly.Python.valueToCode(block, "IMG", 2);
        let path = Blockly.Python.valueToCode(block, "PATH", 2);
        return `imwrite(${img},${path})\r\n`;
    };


    // storm_os 输出

    Blockly.Python.STORM_OS_PRINT = function (block) {
        let text = Blockly.Python.valueToCode(block, "TEXT", 2);
        return `prints(${text})\r\n`;
    };


    // AI-人脸识别

    Blockly.Python.STORM_OS_get_face_attributes = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);
        Blockly.Python.definitions_.SDK_FaceAttributeDetector = "from SenseTime.sdk.FaceAttributeDetector import *"
        return [`get_face_attributes(${input})`, 1];
    };
    Blockly.Python.STORM_OS_is_face_smiled = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);
        Blockly.Python.definitions_.SDK_FaceAttributeDetector = "from SenseTime.sdk.FaceAttributeDetector import *"
        return [`is_face_smiled(${input})`, 1];
    };
    Blockly.Python.STORM_OS_get_face_attribute_two = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);
        let status = block.getFieldValue('STATUS')
        Blockly.Python.definitions_.SDK_FaceAttributeDetector = "from SenseTime.sdk.FaceAttributeDetector import *"
        return [`get_face_attribute(${input},"${status}")`, 1];
    };
    Blockly.Python.STORM_OS_is_face_existed = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);
        Blockly.Python.definitions_.SDK_FaceDetector = "from SenseTime.sdk.FaceDetector import *"
        return [`is_face_existed(${input})`, 1];
    };
    Blockly.Python.STORM_OS_detect_face = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);
        Blockly.Python.definitions_.SDK_FaceDetector = "from SenseTime.sdk.FaceDetector import *"
        return [`detect_face(${input})`, 1];
    };
    Blockly.Python.STORM_OS_extract_face_feature = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);
        Blockly.Python.definitions_.SDK_FaceFeatureDetector = "from SenseTime.sdk.FaceFeatureDetector import *"
        return [`extract_face_feature(${input})`, 1];
    };
    Blockly.Python.STORM_OS_calculate_feature_similarity = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);
        let input2 = Blockly.Python.valueToCode(block, "INPUT2", 2);
        Blockly.Python.definitions_.SDK_FaceFeatureDetector = "from SenseTime.sdk.FaceFeatureDetector import *"
        return [`calculate_feature_similarity(${input},${input2})`, 1];
    };
    Blockly.Python.STORM_OS_get_face_pose = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);
        Blockly.Python.definitions_.SDK_FacePoseDetector = "from SenseTime.sdk.FacePoseDetector import *"
        return [`get_face_pose(${input})`, 1];
    };


    // AI-人体识别

    Blockly.Python.STORM_OS_is_hand_existed = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);
        Blockly.Python.definitions_.SDK_HandDetector = "from SenseTime.sdk.HandDetector import *"
        return [`is_hand_existed(${input})`, 1];
    };
    Blockly.Python.STORM_OS_detect_hand = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);
        Blockly.Python.definitions_.SDK_HandDetector = "from SenseTime.sdk.HandDetector import *"
        return [`detect_hand(${input})`, 1];
    };
    Blockly.Python.STORM_OS_is_gesture_existed = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);
        let status = block.getFieldValue("STATUS");
        Blockly.Python.definitions_.SDK_HandDetector = "from SenseTime.sdk.HandDetector import *"
        return [`is_gesture_existed(${input},"${status}")`, 1];
    };
    Blockly.Python.STORM_OS_detect_gesture = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);
        Blockly.Python.definitions_.SDK_HandDetector = "from SenseTime.sdk.HandDetector import *"
        return [`detect_gesture(${input})`, 1];
    };

    Blockly.Python.STORM_OS_detect_hand_points = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);
        Blockly.Python.definitions_.SDK_HandPointsDetector = "from SenseTime.sdk.HandPointsDetector import *"
        return [`detect_hand_points(${input})`, 1];
    };
    Blockly.Python.STORM_OS_is_body_existed = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);
        Blockly.Python.definitions_.SDK_BodyDetector = "from SenseTime.sdk.BodyDetector import *"
        return [`is_body_existed(${input})`, 1];
    };
    Blockly.Python.STORM_OS_detect_body = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);
        Blockly.Python.definitions_.SDK_BodyDetector = "from SenseTime.sdk.BodyDetector import *"
        return [`detect_body(${input})`, 1];
    };
    Blockly.Python.STORM_OS_detect_body_key_points = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);
        Blockly.Python.definitions_.SDK_BodyTracker = "from SenseTime.sdk.BodyTracker import *"
        return [`detect_body_key_points(${input})`, 1];
    };

    // AI-图像检测

    Blockly.Python.STORM_OS_is_ball_existed = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);

        Blockly.Python.definitions_.sdk_BallDetector = "from SenseTime.sdk.BallDetector import *"

        return [`is_ball_existed(${input})`, 1];
    };
    Blockly.Python.STORM_OS_detect_ball = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);

        Blockly.Python.definitions_.sdk_BallDetector = "from SenseTime.sdk.BallDetector import *"

        return [`detect_ball(${input})`, 1];
    };
    Blockly.Python.STORM_OS_classify_image = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);

        Blockly.Python.definitions_.sdk_ClassificationDetector = "from SenseTime.sdk.ClassificationDetector import *"

        return [`classify_image(${input})`, 1];
    };
    Blockly.Python.STORM_OS_detect_lane_line = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);

        Blockly.Python.definitions_.utils_YellowLaneLineDetector = "from SenseTime.utils.YellowLaneLineDetector import *"

        return [`detect_lane_line(${input})`, 1];
    };
    Blockly.Python.STORM_OS_get_pid_speed = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);
        let input2 = Blockly.Python.valueToCode(block, "INPUT2", 2);
        let speed = block.getFieldValue("SPEED");

        Blockly.Python.definitions_.utils_PID_Control = "from SenseTime.utils.PID_Control import *"

        return [`get_pid_speed(${input},${input2},"${speed}")`, 1];
    };
    Blockly.Python.STORM_OS_detect_plant = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);

        Blockly.Python.definitions_.utils_PlantDetector = "from SenseTime.utils.PlantDetector import *"

        return [`detect_plant(${input})`, 1];
    };
    Blockly.Python.STORM_OS_detect_mineral = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);

        Blockly.Python.definitions_.utils_MineralDetector = "from SenseTime.utils.MineralDetector import *"

        return [`detect_mineral(${input})`, 1];
    };
    Blockly.Python.STORM_OS_get_result_label = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);

        Blockly.Python.definitions_.utils_PlantDetector = "from SenseTime.utils.PlantDetector import *"

        return [`get_result_label(${input})`, 1];
    };
    Blockly.Python.STORM_OS_get_result_coordinate = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);
        let position = block.getFieldValue("POSITION");

        Blockly.Python.definitions_.utils_PlantDetector = "from SenseTime.utils.PlantDetector import *"

        return [`get_result_coordinate(${input},"${position}")`, 1];
    };

    // AI-机器学习
    Blockly.Python.STORM_OS_extract_imageNet = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);

        Blockly.Python.definitions_.sdk_ImagetNetFeatureExtractor = "from SenseTime.sdk.ImagetNetFeatureExtractor import *"

        return [`extract_imageNet(${input})`, 1];
    };
    Blockly.Python.STORM_OS_train_classifier = function (block) {
        let name = Blockly.Python.valueToCode(block, "NAME", 2);

        Blockly.Python.definitions_.utils_GeneralClassifier = "from SenseTime.utils.GeneralClassifier import *"

        return [`train_classifier(${name})`, 1];
    };
    Blockly.Python.STORM_OS_save_model = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);
        let rename = Blockly.Python.valueToCode(block, "RENAME", 2);

        Blockly.Python.definitions_.utils_GeneralClassifier = "from SenseTime.utils.GeneralClassifier import *"

        return `save_model(${input},${rename})\r\n`;
    };
    Blockly.Python.STORM_OS_load_model = function (block) {
        let input = Blockly.Python.valueToCode(block, "NAME", 2);

        Blockly.Python.definitions_.utils_GeneralClassifier = "from SenseTime.utils.GeneralClassifier import *"

        return [`load_model(${input})`, 1];
    };
    Blockly.Python.STORM_OS_predict = function (block) {
        let input = Blockly.Python.valueToCode(block, "INPUT", 2);
        let input2 = Blockly.Python.valueToCode(block, "INPUT2", 2);

        Blockly.Python.definitions_.utils_GeneralClassifier = "from SenseTime.utils.GeneralClassifier import *"

        return [`predict(${input},${input2})`, 1];
    };

    // AI-智能语音

    Blockly.Python.STORM_OS_speak = function (block) {
        let text = Blockly.Python.valueToCode(block, "TEXT", 2);

        Blockly.Python.definitions_.utils_AudioClassifier = "from SenseTime.utils.AudioClassifier import *"

        return `speak(${text})\r\n`;
    };
    Blockly.Python.STORM_OS_classify_audio = function (block) {
        let fileName = Blockly.Python.valueToCode(block, "FILENAME", 2);

        Blockly.Python.definitions_.utils_AudioClassifier = "from SenseTime.utils.AudioClassifier import *"

        return [`classify_audio(${fileName})`, 1];
    };




    //   列表
    Blockly.Python.data_listHead = "list_"
    Blockly.Python.data_listcontents = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';

        listname = Blockly.Python.data_listHead + listname

        return [listname, 1]
    };
    Blockly.Python.data_addtolist = function (a) {
        let str = Blockly.Python.valueToCode(a, "ITEM", 2)

        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        return `${listname}.append(${str})\r\n`
    };

    Blockly.Python.data_deleteoflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        let line = Blockly.Python.valueToCode(a, "INDEX", 2)

        if (isNaN(Number(line))) {
            let str = line.replace(/\(|\)/ig, "")
            if (isNaN(Number(str))) {
                line = line + " - 1"
            } else {
                line = Number(line) > 0 ? Number(line) - 1 : 0;
            }
        } else {
            line = Number(line) > 0 ? Number(line) - 1 : 0;
        }
        return `del ${listname}[${line}]\r\n`
    };

    Blockly.Python.data_deletealloflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname
        return `del ${listname}[:]\r\n`
    };

    Blockly.Python.data_insertatlist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        let index = Blockly.Python.valueToCode(a, "INDEX", 2)
        if (isNaN(Number(index))) {
            let str = index.replace(/\(|\)/ig, "")
            if (isNaN(Number(str))) {
                index = index + " - 1"
            } else {
                index = Number(index) > 0 ? Number(index) - 1 : 0;
            }
        } else {
            index = Number(index) > 0 ? Number(index) - 1 : 0;
        }


        let item = Blockly.Python.valueToCode(a, "ITEM", 2)
        return `${listname}.insert(${index}, ${item})\r\n`
    };
    Blockly.Python.data_replaceitemoflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        let index = Blockly.Python.valueToCode(a, "INDEX", 2)
        if (isNaN(Number(index))) {
            let str = index.replace(/\(|\)/ig, "")
            if (isNaN(Number(str))) {
                index = index + " - 1"
            } else {
                index = Number(index) > 0 ? Number(index) - 1 : 0;
            }
        } else {
            index = Number(index) > 0 ? Number(index) - 1 : 0;
        }

        let item = Blockly.Python.valueToCode(a, "ITEM", 2)
        return `${listname}[${index}] = ${item}\r\n`
    };

    Blockly.Python.data_listcontainsitem = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        let str = Blockly.Python.valueToCode(a, "ITEM", 2)
        return [`${str} in ${listname}`, 2]
    };

    Blockly.Python.data_itemnumoflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        let str = Blockly.Python.valueToCode(a, "ITEM", 2)
        return [`${listname}.index(${str})`, 1]
    };

    Blockly.Python.data_itemoflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        let num = Blockly.Python.valueToCode(a, "INDEX", 2)

        if (isNaN(Number(num))) {
            let str = num.replace(/\(|\)/ig, "")
            if (isNaN(Number(str))) {
                num = num + " - 1"
            } else {
                num = Number(num) > 0 ? Number(num) - 1 : 0;
            }
        } else {
            num = Number(num) > 0 ? Number(num) - 1 : 0;
        }
        return [`${listname}[${num}]`, 1]
    };
    Blockly.Python.data_lengthoflist = function (a) {
        let list = a.getFieldValue('LIST')
        var listname = a.workspace.getVariableById(list) ? a.workspace.getVariableById(list).name : 'null';
        listname = Blockly.Python.data_listHead + listname

        return [`len(${listname})`, 1]
    };



    //运算
    Blockly.Python.operator_add = function (a) {
        let NUM1 = Blockly.Python.valueToCode(a, "NUM1", 2) || 1
        let NUM2 = Blockly.Python.valueToCode(a, "NUM2", 2) || 1
        return [`${NUM1} + ${NUM2}`, 2]
    };
    Blockly.Python.operator_subtract = function (a) {
        let NUM1 = Blockly.Python.valueToCode(a, "NUM1", 2)
        let NUM2 = Blockly.Python.valueToCode(a, "NUM2", 2)
        return [`${NUM1} - ${NUM2}`, 2]
    };
    Blockly.Python.operator_multiply = function (a) {
        let NUM1 = Blockly.Python.valueToCode(a, "NUM1", 2)
        let NUM2 = Blockly.Python.valueToCode(a, "NUM2", 2)
        return [`${NUM1} * ${NUM2}`, 2]
    };
    Blockly.Python.operator_divide = function (a) {
        let NUM1 = Blockly.Python.valueToCode(a, "NUM1", 2)
        let NUM2 = Blockly.Python.valueToCode(a, "NUM2", 2)
        return [`${NUM1} / ${NUM2}`, 2]
    };
    Blockly.Python.math_arithmetic = function (a) {
        let RANDOMSTART = Blockly.Python.valueToCode(a, "A", 2)
        let OP = a.getFieldValue("OP")
        let RANDOMEND = Blockly.Python.valueToCode(a, "B", 2)
        return [`${RANDOMSTART} ${OP} ${RANDOMEND}`, 2]
    };
    Blockly.Python.operator_random = function (a) {
        let RANDOMSTART = Blockly.Python.valueToCode(a, "FROM", 2)
        let RANDOMEND = Blockly.Python.valueToCode(a, "TO", 2)
        return [`rcu.GetRandom(${RANDOMSTART},${RANDOMEND})`, 1]
    };
    Blockly.Python.operator_lt = function (a) {
        let OPERAND1 = Blockly.Python.valueToCode(a, "OPERAND1", 2)
        let OPERAND2 = Blockly.Python.valueToCode(a, "OPERAND2", 2)
        return [`${OPERAND1} < ${OPERAND2}`, 2]
    };
    Blockly.Python.operator_equals = function (a) {
        let OPERAND1 = Blockly.Python.valueToCode(a, "OPERAND1", 2)
        let OPERAND2 = Blockly.Python.valueToCode(a, "OPERAND2", 2)
        return [`${OPERAND1} == ${OPERAND2}`, 2]
    };
    Blockly.Python.operator_gt = function (a) {
        let OPERAND1 = Blockly.Python.valueToCode(a, "OPERAND1", 2)
        let OPERAND2 = Blockly.Python.valueToCode(a, "OPERAND2", 2)
        return [`${OPERAND1} > ${OPERAND2}`, 2]
    };
    Blockly.Python.operator_and = function (a) {
        let OPERAND1 = Blockly.Python.valueToCode(a, "OPERAND1", 2) || "()"
        let OPERAND2 = Blockly.Python.valueToCode(a, "OPERAND2", 2) || "()"
        return [`${OPERAND1} and ${OPERAND2}`, 2]
    };
    Blockly.Python.operator_or = function (a) {
        let OPERAND1 = Blockly.Python.valueToCode(a, "OPERAND1", 2) || "()"
        let OPERAND2 = Blockly.Python.valueToCode(a, "OPERAND2", 2) || "()"
        return [`${OPERAND1} or ${OPERAND2}`, 2]
    };
    Blockly.Python.operator_not = function (a) {
        let OPERAND = Blockly.Python.valueToCode(a, "OPERAND", 2)
        return [`not(${OPERAND})`, 2]
    };
    Blockly.Python.operator_mod = function (a) {
        let NUM1 = Blockly.Python.valueToCode(a, "NUM1", 2)
        let NUM2 = Blockly.Python.valueToCode(a, "NUM2", 2)
        return [`${NUM1} % ${NUM2}`, 2]
    };
    Blockly.Python.operator_round = function (a) {
        let NUM = Blockly.Python.valueToCode(a, "NUM", 2)
        return [`round(${NUM})`, 2]
    };
    Blockly.Python.operator_mathop = function (a) {
        Blockly.Python.definitions_.Math = "import math";
        let OPERATOR = a.getFieldValue("OPERATOR")
        let NUM = Blockly.Python.valueToCode(a, "NUM", 2)
        let str = ''
        if (OPERATOR === "abs") {
            str = `math.fabs(${NUM})`
        } else if (OPERATOR === "e ^") {
            str = `math.pow(math.e,${NUM})`
        } else if (OPERATOR === "10 ^") {
            str = `math.pow(10,${NUM})`
        } else {
            str = `math.${OPERATOR}(${NUM})`
        }
        return [str, 2]
    };

    Blockly.Python.operator_join = function (a) {
        let string1 = Blockly.Python.valueToCode(a, "STRING1", 2)
        let string2 = Blockly.Python.valueToCode(a, "STRING2", 2)
        return [`"".join((${string1},${string2}))`, 1]
    };

    Blockly.Python.operator_letter_of = function (a) {
        let letter = Blockly.Python.valueToCode(a, "LETTER", 2)
        let string = Blockly.Python.valueToCode(a, "STRING", 2)

        if (!isNaN(Number(letter))) {
            if (letter <= 0) {
                letter = 0
            } else {
                letter -= 1
            }
        } else {
            letter = 1
        }

        return [`${string}[${letter}]`, 1]
    };

    Blockly.Python.operator_length = function (a) {
        let string = Blockly.Python.valueToCode(a, "STRING", 2)
        return [`len(${string})`, 1]
    };

    Blockly.Python.operator_contains = function (a) {
        let string1 = Blockly.Python.valueToCode(a, "STRING1", 2)
        let string2 = Blockly.Python.valueToCode(a, "STRING2", 2)
        return [`${string2} in ${string1}`, 1]
    };
    Blockly.Python.operator_isStringSame = function (a) {
        let StringOne = Blockly.Python.valueToCode(a, "string_one", 3)
        let StringTwo = Blockly.Python.valueToCode(a, "string_two", 3)
        return [`rcu.isStringSame(${StringOne},${StringTwo})`, 1]
    };


    //部分模块转换

    Blockly.Python.text = function (a) {
        let textValue = a.getFieldValue("TEXT") || ''
        if (a.getParent().type === "extSensor_SetDisplayLattice") {
            return [`"${textValue}"`, 1]
        } else {
            if (isNaN(textValue * 1)) {
                textValue = '"' + textValue + '"'
                return [textValue, 1]
            } else {
                return [textValue, 1]
            }
        }
    }

    Blockly.Python.textvalue = function (a) {
        let textValue = a.getFieldValue("TEXT") || ''
        return ['"' + textValue + '"', 1]

    }

    Blockly.Python.math_integer = function (a) {
        let value = a.getFieldValue('NUM') || 'null'
        return [value, 1]
    };

    Blockly.Python.math_number = function (a) {
        let value = a.getFieldValue('NUM') || 'null'
        return [value, 1]
    };
    Blockly.Python.math_whole_number = function (a) {
        let value = a.getFieldValue('NUM') || 'null'
        return [value, 1]
    };

    Blockly.Python.jmd_time_menu = function (a) {
        let time = a.getFieldValue('TIME') || 'null'
        return [time, 1]
    };

    Blockly.Python.motor_speed_menu = function (a) {
        let value = a.getFieldValue('VALUE') || 'null'
        return [value, 1]
    };

    Blockly.Python.motor_angle_menu = function (a) {
        let angle = a.getFieldValue('ANGLE') || 'null'
        return [angle, 1]
    };

    Blockly.Python.motor_angle_menu_two = function (a) {
        let angle = a.getFieldValue('ANGLE') || 'null'
        return [angle, 1]
    };

    Blockly.Python.motor_angle_menu_three = function (a) {
        let angle = a.getFieldValue('ANGLE') || 'null'
        return [angle, 1]
    };

    Blockly.Python.show_lines_menu = function (a) {
        let lines = a.getFieldValue('LINES') || 'null'
        return [lines, 1]
    };
    Blockly.Python.play_folder_menu = function (a) {
        let foldername = a.getFieldValue('FOLDERNAME') || 'null'
        return [foldername, 1]
    };

    Blockly.Python.play_music_menu = function (a) {
        let musicname = a.getFieldValue('MUSICNAME') || 'null'
        return [musicname, 1]
    };

    Blockly.Python.colour_picker = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };

    Blockly.Python.colour_picker_Red = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };

    Blockly.Python.colour_picker_Orange = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.Python.colour_picker_Yellow = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.Python.colour_picker_Green = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.Python.colour_picker_Blue = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.Python.colour_picker_Indigo = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.Python.colour_picker_Purple = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };
    Blockly.Python.colour_picker_White = function (a) {
        let color = a.getFieldValue('COLOUR') || 'null'
        return [color, 1]
    };

    Blockly.Python.matrix = function (a) {
        let matrix = a.getFieldValue('MATRIX') || 'null'
        return [matrix, 1]
    };

    Blockly.Python.AI_city_menu = function (a) {
        let value = a.getFieldValue('CITYVALUE') || 'null'
        return ['"' + value + '"', 1]
    }

    Blockly.Python.AI_PostAngelValue = function (a) {
        let value = a.getFieldValue('VALUE') || 'null'
        return [value, 1]
    }
    Blockly.Python.AI_PostAngelValue2 = function (a) {
        let value = a.getFieldValue('VALUE') || 'null'
        return [value, 1]
    }







    // 变量
    Blockly.Python.variables = {};
    Blockly.Python.variablesHead = "var_";
    Blockly.Python.data_variable = function (a) {
        let varible = a.workspace.getVariableById(a.getFieldValue("VARIABLE")) ? a.workspace.getVariableById(a.getFieldValue("VARIABLE")).name : ""

        varible = Blockly.Python.variablesHead + varible

        return [varible, Blockly.Python.ORDER_ATOMIC]
    };
    Blockly.Python.data_setvariableto = function (a) {
        let varible = a.workspace.getVariableById(a.getFieldValue("VARIABLE")) ? a.workspace.getVariableById(a.getFieldValue("VARIABLE")).name : ""
        let num = Blockly.Python.valueToCode(a, "VALUE", 2)
        varible = Blockly.Python.variablesHead + varible
        return `${varible} = ${num}\r\n`
    };
    Blockly.Python.data_changevariableby = function (a) {
        let varible = a.workspace.getVariableById(a.getFieldValue("VARIABLE")) ? a.workspace.getVariableById(a.getFieldValue("VARIABLE")).name : ""
        let num = Blockly.Python.valueToCode(a, "VALUE", 2)
        varible = Blockly.Python.variablesHead + varible
        return `${varible} += ${num}\r\n`
    };




    // 自制积木

    // %s 数字类型控件 argument_reporter_string_number
    // %d 布尔类型控件 argument_reporter_boolean


    Blockly.Python.procedures_definition = function (a) {
        let b = Blockly.Python.blockToCode(a.workspace.getBlockById(a.getChildren(a)[0].id))
        let passEnd = a.getNextBlock() ? "" : "  pass\n"
        return "def " + b + ":[GLOBAL]\r\n" + passEnd;
    };
    Blockly.Python.procedures_prototype = function (a) {
        // console.log('procedures_prototype', a)
        let fnName = a.getProcCode().replace(/%[sbn\s]|\s/ig, '').trim()
        let children = a.getChildren(a)
        let array = []
        for (let i = 0; i < children.length; i++) {
            if (a.workspace.getBlockById(children[i].id)) {
                let value = Blockly.Python.blockToCode(a.workspace.getBlockById(children[i].id))
                array.push(value[0])
            }
        }
        fnName += `(${array.join(',')})`

        return fnName;
    };
    Blockly.Python.argument_reporter_boolean = function (a) {
        // console.log('argument_reporter_boolean', a)
        let text = a.inputList[0].fieldRow[0].getText()
        // console.log(a.inputList[0].fieldRow[0].getText())
        return [text, 1];
    };
    Blockly.Python.argument_reporter_string_number = function (a) {
        // console.log('argument_reporter_string_number', a)
        let text = a.inputList[0].fieldRow[0].getText()
        // console.log(a.inputList[0].fieldRow[0].getText())

        return [text, 1];
    };

    Blockly.Python.procedures_call = function (a) {
        // console.log('procedures_call', a)

        let array = []
        let fnName = a.getProcCode().replace(/(%s|%b|%n)|\s/ig, '')

        for (let i = 0; i < a.inputList.length; i++) {
            if (a.inputList[i].name !== '') {
                let blocks = a.inputList[i].connection.targetBlock()
                if (blocks) {
                    let child = Blockly.Python.blockToCode(a.workspace.getBlockById(blocks.id))
                    if (Array.isArray(child)) {
                        var arg = child[0]
                        if (child[1] === 2 || child[1] === 99) {
                            arg = '(' + arg + ')'
                        }
                        if (!(/[^\s]/ig.test(child[0]))) {
                            array.push('"' + arg + '"')
                        } else {
                            array.push(arg)
                        }
                    } else {
                        array.push(child)
                    }
                } else {
                    array.push('False')
                }
            }
        }

        fnName += `(${array.join(',')})`

        return `${fnName}\r\n`;
    };


}

export {
    python_STROM_OS
}
